module.exports = __webpack_public_path__ + "unallocated-icon2.png?5ce909642efb3dc63456552d8090071a";